import { render, staticRenderFns } from "./StyleCopyMain.vue?vue&type=template&id=25ba736c&"
import script from "./StyleCopyMain.vue?vue&type=script&lang=js&"
export * from "./StyleCopyMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports